import React, { useMemo } from 'react'
import WhatsCoveredDrawerContent from './WhatsCoveredDrawerContent'
import { DrawerApiData } from './WhatsCoveredDrawer.types'
import useViewport from '../../../../../../../hooks/useViewPort'
import WizardSidebar from '../../../../../Drawer/Drawer'

type WhatsCoveredDrawerProps = {
  drawerApiData: DrawerApiData
  isOpen: boolean
  handleDrawerClose: () => void
  handleDetailsAndFaqVisit: () => void
}

const WhatsCoveredDrawer = ({
  drawerApiData,
  isOpen,
  handleDrawerClose,
  handleDetailsAndFaqVisit,
}: WhatsCoveredDrawerProps) => {
  const { isMobile } = useViewport()

  const {
    marketing: {
      learnMoreModal: {
        headline = '',
        headlineMobile = '',
        whyExtendHeading = '',
        whyExtend1Icon = '',
        whyExtend2Icon = '',
        whyExtend1 = '',
        whyExtend2 = '',
      } = {},
      offerTypeModalV2: {
        coverageBulletsHeading = '',
        coverageBullet1 = '',
        coverageBullet2 = '',
        coverageBullet3 = '',
        coverageBullet2Mobile = '',
        coverageBullet3Mobile = '',
      } = {},
    } = {},
  } = drawerApiData || {}

  const whatsCoveredDrawerHeadline = isMobile ? headlineMobile : headline

  const includedCoverageBulletPointsDesktop = useMemo(
    () => [coverageBullet1, coverageBullet2, coverageBullet3],
    [coverageBullet1, coverageBullet2, coverageBullet3],
  )
  const includedCoverageBulletPointsMobile = useMemo(
    () => [coverageBullet1, coverageBullet2Mobile, coverageBullet3Mobile],
    [coverageBullet1, coverageBullet2Mobile, coverageBullet3Mobile],
  )
  const includedCoverageBulletPoints = isMobile ? includedCoverageBulletPointsMobile : includedCoverageBulletPointsDesktop

  return (
    <WizardSidebar
      id="whats-covered-drawer"
      HeaderTitle={null}
      onCloseButtonClick={handleDrawerClose}
      onClickOutside={handleDrawerClose}
      isOpen={isOpen}
      Content={(
        <WhatsCoveredDrawerContent
          whyExtendHeading={whyExtendHeading}
          whyExtend1Icon={whyExtend1Icon}
          whyExtend2Icon={whyExtend2Icon}
          whyExtend1={whyExtend1}
          whyExtend2={whyExtend2}
          headline={whatsCoveredDrawerHeadline}
          coverageBulletsHeading={coverageBulletsHeading}
          includedCoverageBulletPoints={includedCoverageBulletPoints}
          handleDetailsAndFaqVisit={handleDetailsAndFaqVisit}
        />
      )}
    />
  )
}

export default WhatsCoveredDrawer
